import RecordMgmt from "../A/RecordMgmt/RecordMgmt"
import { Toolbar } from "primereact/toolbar"
import CustomToolBar from "../../ToolBar/customToolbar"
import { useRef, useContext } from "react"
import { Toast } from "primereact/toast"
import { showMessage } from "../../utils/utils"
import { GpraContext } from "../../../../context/gpraContext"
import { endpoints } from "../../../../config/gpraApiEndpoints"
import { INTERVIEW_SECTIONS, INTERVIEW_TYPES } from "../../types/interviewTypes"
import { useNavigate } from "react-router-dom"
import { UserContext } from "../../../../context/userContext"
import gpraStyles from "../../../../styles/Participant-GPRA.module.css"
import DemographicsContainer from "../../Containers/DemographicsContainer"
import PlannedServices1Container from "../../Containers/PlannedServices1Container"
import PlannedServices2Container from "../../Containers/PlannedServices2Container"
import PlannedServices3Container from "../../Containers/PlannedServices3Container"
import PlannedServices4Container from "../../Containers/PlannedServices4Container"
import SubstanceUse1Container from "../../Containers/SubstanceUse1Container"
import SubstanceUse2Container from "../../Containers/SubstanceUse2Container"
import SubstanceUse3Container from "../../Containers/SubstanceUse3Container"
import FamilyContainer from "../../Containers/FamilyContainer"
import EducationContainer from "../../Containers/EducationContainer"
import LegalContainer from "../../Containers/LegalContainer"
import MentalContainer from "../../Containers/MentalContainer"
import SocialContainer from "../../Containers/SocialContainer"
import ProgramQuestionsContainer from "../../Containers/ProgramQuestionsContainer"
import DischargeContainer from "../../Containers/DischargeContainer"
import FollowUpContainer from "../../Containers/FollowUpContainer"
import ServicesReceived1Container from "../../Containers/ServicesReceived1Container"
import ServicesReceived2Container from "../../Containers/ServicesReceived2Container"
import ServicesReceived3Container from "../../Containers/ServicesReceived3Container"
import ServicesReceived4Container from "../../Containers/ServicesReceived4Container"
import ServicesReceived5Container from "../../Containers/ServicesReceived5Container"
import { RELOAD_TYPES } from "../../types/interviewTypes"
import Start from "../A/Start/Start"
const Summary = () => {
  const {
    handleSubmitPut,
    interview,
    interviewType,
    handleSummary,
    handleLoadFinish,
    handleInterviewType,
    handleReloadStatus,
    handleActiveIndex,
    handleSectionsCompleted,
    setAdministrativeInterview,
    sections,
    activeIndex,
    administrativeInterview,
    clearContext,
    editMode,
  } = useContext(GpraContext)

  const userCtx = useContext(UserContext)

  const { participant_name_first, participant_name_last } =
    useContext(UserContext)

  const toast = useRef(null)
  const navigate = useNavigate()

  const allSectionsCompleted = () => {
    let sectionsFiltered = sections
      .filter(
        (s) =>
          s.section !== "summary" &&
          s.section !== "recordMgmt" &&
          s.section !== "start"
      )
      .map((s) => {
        return s.section
      })
    let completed = true
    if (!interview["recordManagement"]?.staff_id) {
      completed = false
    }
    if (!administrativeInterview) {
      sectionsFiltered = sectionsFiltered.filter(
        (s) => s === "followUp" || s === "discharge"
      )
    }
    sectionsFiltered.forEach((s) => {
      const idKey = Object.keys(interview[s]).find((k) => k.endsWith("id"))
      const idValue = interview[s][idKey]
      if (idValue === 0) {
        completed = false
      }
    })
    return completed
  }
  const saveData = (setNextForm, prevForm, setNavigationItem) => {
    if (prevForm) {
      setNextForm(sections[activeIndex - 1].section)
      handleSummary(false)
      setNavigationItem()
    } else {
      if (allSectionsCompleted()) {
        handleSubmitPut(endpoints.FINISH_INTERVIEW, {
          gpra_record: interview[INTERVIEW_SECTIONS.RECORD_MGMT].record_id,
          gpra_interview_type: interviewType,
          participant_name:
            participant_name_first + " " + participant_name_last,
          edit_mode: editMode,
          edited_by: userCtx.session?.user?.staff_id,
        })
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              handleLoadFinish(false)
              handleReloadStatus(RELOAD_TYPES.summary)
              handleInterviewType("")
              handleActiveIndex(0)
              handleSectionsCompleted({})
              setAdministrativeInterview(null)
              clearContext()
              navigate("/participant/gpra-forms")
            }
          })
          .catch((err) => {
            handleLoadFinish(false)
            showMessage(false, "error", toast)
          })
      } else {
        handleLoadFinish(false)
        showMessage(
          false,
          "Can't finish the Interview. Some sections are not completed.",
          toast
        )
      }
    }
  }
  const sectionEnabled = (section) => {
    return !!sections.find((s) => s.section === section)
  }
  return (
    <>
      <Toast ref={toast} />
      <Toolbar
        className={gpraStyles.mb2}
        right={
          <CustomToolBar
            showFinish
            prevForm={true}
            saveData={saveData}
            toast={toast}
            nextForm={false}
          />
        }
      ></Toolbar>
      {interviewType === INTERVIEW_TYPES.INTAKE && (
        <>
          {sectionEnabled("recordMgmt") && (
            <RecordMgmt showToolBar={false} disabled />
          )}
          {sectionEnabled(INTERVIEW_SECTIONS.DEMOGRAPHICS) && (
            <DemographicsContainer showToolBar={false} disabled />
          )}
          {sectionEnabled(INTERVIEW_SECTIONS.PLANNED_SERVICES_1) && (
            <PlannedServices1Container showToolBar={false} disabled />
          )}
          {sectionEnabled(INTERVIEW_SECTIONS.PLANNED_SERVICES_2) && (
            <PlannedServices2Container showToolBar={false} disabled />
          )}
          {sectionEnabled(INTERVIEW_SECTIONS.PLANNED_SERVICES_3) && (
            <PlannedServices3Container showToolBar={false} disabled />
          )}
          {sectionEnabled(INTERVIEW_SECTIONS.PLANNED_SERVICES_4) && (
            <PlannedServices4Container showToolBar={false} disabled />
          )}
        </>
      )}
      {(interviewType === INTERVIEW_TYPES.FOLLOW_UP ||
        interviewType === INTERVIEW_TYPES.DISCHARGE) && (
        <>{sectionEnabled("start") && <Start showToolBar={false} disabled />}</>
      )}
      {sectionEnabled(INTERVIEW_SECTIONS.SUBSTANCE_USE_1) && (
        <SubstanceUse1Container showToolBar={false} disabled />
      )}
      {sectionEnabled(INTERVIEW_SECTIONS.SUBSTANCE_USE_2) && (
        <SubstanceUse2Container showToolBar={false} disabled />
      )}
      {sectionEnabled(INTERVIEW_SECTIONS.SUBSTANCE_USE_3) && (
        <SubstanceUse3Container showToolBar={false} disabled />
      )}
      {sectionEnabled(INTERVIEW_SECTIONS.FAMILY) && (
        <FamilyContainer showToolBar={false} disabled />
      )}
      {sectionEnabled(INTERVIEW_SECTIONS.EDUCATION) && (
        <EducationContainer showToolBar={false} disabled />
      )}
      {sectionEnabled(INTERVIEW_SECTIONS.LEGAL) && (
        <LegalContainer showToolBar={false} disabled />
      )}
      {sectionEnabled(INTERVIEW_SECTIONS.MENTAL) && (
        <MentalContainer showToolBar={false} disabled />
      )}
      {sectionEnabled(INTERVIEW_SECTIONS.SOCIAL) && (
        <SocialContainer showToolBar={false} disabled />
      )}
      {(interviewType === INTERVIEW_TYPES.FOLLOW_UP ||
        interviewType === INTERVIEW_TYPES.DISCHARGE) &&
        sectionEnabled(INTERVIEW_SECTIONS.PROGRAM) && (
          <ProgramQuestionsContainer showToolBar={false} disabled />
        )}
      {interviewType === INTERVIEW_TYPES.FOLLOW_UP &&
        sectionEnabled(INTERVIEW_SECTIONS.FOLLOW_UP) && (
          <FollowUpContainer showToolBar={false} disabled />
        )}
      {interviewType === INTERVIEW_TYPES.DISCHARGE &&
        sectionEnabled(INTERVIEW_SECTIONS.DISCHARGE) && (
          <DischargeContainer showToolBar={false} disabled />
        )}
      {interviewType === INTERVIEW_TYPES.DISCHARGE && (
        <>
          {sectionEnabled(INTERVIEW_SECTIONS.SERVICES_RECEIVED_1) && (
            <ServicesReceived1Container showToolBar={false} disabled />
          )}
          {sectionEnabled(INTERVIEW_SECTIONS.SERVICES_RECEIVED_2) && (
            <ServicesReceived2Container showToolBar={false} disabled />
          )}
          {sectionEnabled(INTERVIEW_SECTIONS.SERVICES_RECEIVED_3) && (
            <ServicesReceived3Container showToolBar={false} disabled />
          )}
          {sectionEnabled(INTERVIEW_SECTIONS.SERVICES_RECEIVED_4) && (
            <ServicesReceived4Container showToolBar={false} disabled />
          )}
          {sectionEnabled(INTERVIEW_SECTIONS.SERVICES_RECEIVED_5) && (
            <ServicesReceived5Container showToolBar={false} disabled />
          )}
        </>
      )}
      <Toolbar
        className="mt-4"
        right={
          <CustomToolBar
            showFinish
            prevForm={true}
            saveData={saveData}
            toast={toast}
            nextForm={false}
          />
        }
      ></Toolbar>
    </>
  )
}

export default Summary
